import * as React from 'react';
import { FilterCriteria } from './DataGrid.Utils';
import { DataGridColumn } from './DataGrid.Column';
import { TextDataGrid, TextDataGridCtor } from './TextDataGrid';

interface Props<T> {
	id: string;
	columns: DataGridColumn<T>[];
	initialData: T[];
	headerHeight?: number;

	// Valor usado para comparar formar los cellKeys de las celdas
	itemKey: (item: T) => any;

	// Permite indicar que la altura de la columnas se calculará dinámicamente (penaliza el rendimiento)
	variableRowHeight?: boolean;

	// Ancho en pixels de la tabla. Si no se especifica ancho en pixels, se tomará el del padre
	width?: number;
	height?: number;
	maxHeight?: number;
}

export class NumericDataGrid<T> extends React.Component<Props<T>, EmptyState> {

	private textDataGrid = React.createRef<TextDataGrid<T>>();

	constructor(props: Props<T>) {
		super(props);
	}

	componentDidMount(): void {
	}

	componentWillUnmount() {
	}

	componentDidUpdate() {
	}

	getActiveRowData() {
		return this.textDataGrid.current!.getActiveRowData();
	}

	filterBy(searchTextOrCriteria: string | FilterCriteria<T>) {
		this.textDataGrid.current!.filterBy(searchTextOrCriteria);
	}

	isValid() {
		return this.textDataGrid.current!.isValid();
	}

	getData(): T[] {
		return this.textDataGrid.current!.getData();
	}

	getFilteredData(): T[] {
		return this.textDataGrid.current!.getFilteredData();
	}

	render() {

		const TheTextDataGrid: TextDataGridCtor<T> = TextDataGrid;

		return <TheTextDataGrid
			ref={this.textDataGrid}
			id={this.props.id}
			columns={this.props.columns}
			initialData={this.props.initialData}
			itemKey={this.props.itemKey}
			headerHeight={this.props.headerHeight || 36}
			height={this.props.height || 400}
			maxHeight={this.props.maxHeight || 400}
			variableRowHeight={this.props.variableRowHeight}
			propertyType={'decimal'} />;
	}
}

export type NumericDataGridCtor<T> = new (props: Props<T>) => NumericDataGrid<T>;
